import { Container } from './Container';

export function Section({
  id,
  eyebrow,
  title,
  description,
  children,
  className = '',
}) {
  return (
    <section id={id} className={['py-14 sm:py-16', className].join(' ')}>
      <Container>
        {(eyebrow || title || description) && (
          <header className="max-w-2xl">
            {eyebrow && (
              <p className="text-sm font-medium tracking-wide text-slate-600">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                {title}
              </h2>
            )}
            {description && (
              <p className="mt-4 text-base leading-7 text-slate-700">
                {description}
              </p>
            )}
          </header>
        )}
        <div className={(eyebrow || title || description) ? 'mt-10' : ''}>
          {children}
        </div>
      </Container>
    </section>
  );
}

